import { Reducer } from 'redux';
import MapActionTypes from './types';
import { MapLocalState } from './types';

export const initialState: MapLocalState = {};

const reducer: Reducer<MapLocalState> = (state = initialState, action: any) => {
  switch (action.type) {
    case MapActionTypes.QUERY_FEATURE_LAYER_EXTENT_SUCCESS:
      return {
        ...state,
        featureLayerExtent: action.payload.extent,
        resultCount: action.payload.count
      };
    case MapActionTypes.QUERY_FEATURE_LAYER_EXTENT_FAILURE:
      return {
        ...state,
        featureLayerExtent: action.payload,
        resultCount: 0
      };
    case MapActionTypes.QUERY_CLUSTER_EXTENT_SUCCESS:
      return {
        ...state,
        clusterExtent: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
